export default function Access() {
  return (
    <section id="access" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* タイトルエリア */}
        <div className="text-center mb-16">
          <p className="text-sm font-light text-gray-400 mb-2 tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>ACCESS</p>
          <h3 className="text-4xl md:text-5xl font-black text-gray-800 mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
            アクセス情報
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 左側：地図 */}
          <div className="rounded-3xl overflow-hidden shadow-lg h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.8847654321!2d139.4456789!3d35.5678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDM0JzA0LjQiTiAxMznCsDI2JzQ0LjQiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="まごころサービス アクセスマップ"
            ></iframe>
          </div>

          {/* 右側：住所情報 */}
          <div className="flex flex-col justify-center">
            <div className="bg-gradient-to-br from-orange-50 to-pink-50 rounded-3xl p-8 md:p-10">
              <h4 className="text-2xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                まごころサービス 本社
              </h4>
              
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-orange-500"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>住所</p>
                    <p className="text-base text-gray-800 font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      〒194-0036<br />
                      東京都町田市金井ヶ丘4-8
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-train-line text-xl text-orange-500"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>アクセス</p>
                    <p className="text-base text-gray-800 font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      小田急線「鶴川駅」より徒歩15分<br />
                      バス「金井ヶ丘」停留所より徒歩3分
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-xl text-orange-500"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>電話番号</p>
                    <p className="text-base text-gray-800 font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      090-7289-8910
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-time-line text-xl text-orange-500"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>営業時間</p>
                    <p className="text-base text-gray-800 font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      月曜日〜土曜日: 8:00〜18:00<br />
                      定休日: 日曜日・祝日
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-orange-200">
                <p className="text-sm text-gray-600 leading-relaxed font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  お車でお越しの方は、近隣のコインパーキングをご利用ください。事前にご連絡いただければ、駐車場のご案内もいたします。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}